import React, { useState } from "react";

import ErrorOverlaymodal from "../components/ErrorOverlayModal";


function MaintenanceScreen() {

    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setError(null);
    };



    return (
        <div >
            <h1>We are currently updating our system to reflect the outcome of MEPC 83.</h1>
            <p>Please check back later.</p>
        </div>
    );
}

export default MaintenanceScreen;
